import { Component } from '@angular/core';
import {
  RestorationMetricMapWidgetComponent,
} from '../restoration-metric-map-widget/restoration-metric-map-widget.component';

@Component({
  selector: 'tgrid-restoration-metric-impact-level-widget',
  imports: [
    RestorationMetricMapWidgetComponent,
  ],
  templateUrl: './restoration-metric-impact-level-widget.component.html',
  styleUrl: './restoration-metric-impact-level-widget.component.scss',
})
export class RestorationMetricImpactLevelWidgetComponent {

}

